'use client';

import Chip from '@enlighten/design-system/dist/Chip';
import Grid from '@enlighten/design-system/dist/Grid';
import Typography from '@enlighten/design-system/dist/Typography';

import type { ITutorialStepComponent } from '..';
import TutorialLayout from '../TutorialLayout';
import type { TutorialCardProps } from './TutorialCard';
import TutorialCard from './TutorialCard';

export interface TutorialGridTemplateProps extends ITutorialStepComponent {
	title: string;
	list: TutorialCardProps[];
}

export default function TutorialGridTemplate({ title, list, onChangeComponent }: TutorialGridTemplateProps) {
	return (
		<TutorialLayout
			title={
				<>
					<Typography fontSize={{ xs: 26, md: 34 }} fontWeight={700} lineHeight={{ xs: 1.3, md: '44px' }}>
						{title}
					</Typography>
					<Grid container alignItems="center">
						<Typography fontSize={{ xs: 14, md: 16 }} color="grey.800" marginRight={1}>
							추천서비스
						</Typography>
						<Chip
							label={list.length}
							color="primary"
							sx={{
								fontSize: 12,
								fontWeight: 700,
								lineHeight: 1.5,
								height: 18,
								'.MuiChip-label': {
									paddingX: '9px',
								},
							}}
						/>
					</Grid>
				</>
			}
			onChangeComponent={onChangeComponent}
		>
			<Grid display={{ xs: 'flex', md: 'grid' }} gridTemplateColumns="1fr 1fr" flexDirection="column" gap={2} marginTop={2}>
				{list.map((props, i) => (
					<TutorialCard key={i} {...props} />
				))}
			</Grid>
		</TutorialLayout>
	);
}
